export const ISSUES_ENV_TYPES = {
  LOCAL: 'Local',
  QA: 'QA',
  STAGING: 'Staging',
  PROD: 'Production',
};

export const ANALYTICS_ENV_TYPES = {
  [ISSUES_ENV_TYPES.LOCAL]: 'Local',
  [ISSUES_ENV_TYPES.DEV]: 'Dev',
  [ISSUES_ENV_TYPES.QA]: 'QA',
  [ISSUES_ENV_TYPES.STAGING]: 'Staging',
  [ISSUES_ENV_TYPES.PROD]: 'Prod',
};

export const ANALYTICS_MODULE_NAME = 'PJM';

export const MIXPANEL_TOKEN = {
  DEV: '24dd3f06d727b1d4d5d68a81008ba6b6',
  PROD: 'b9f193abcc9f2cffa8c08ef96851e551',
};

export const ISSUES_REGIONS = {
  US: 'US',
  EMEA: 'EMEA',
};

const US_CONFIG = {
  [ISSUES_ENV_TYPES.LOCAL]: {
    DOCS: 'https://docs.b360-qa.autodesk.com',
    APIGEE_HOST: 'https://developer-stg.api.autodesk.com',
    DM_V2: '/dm-qa/v2',
    DM: '/dm-staging/v1/cmd-qa',
    RFIS_ENDPOINT: '/bim360/rfis-qa/v2',
    WORKFLOWS: '/workflows-qa/v1',
    DERIVATIVE_SERVICE: '/derivativeservice/v2',
    DOCS_SDK_CONFIG: {
      region: 'US',
      env: 'Qa',
    },
    MATRIX_CONFIG: {
      env: 'QA',
      region: 'US',
    },
    REPORT_SDK_CONFIG: {
      env: 'Qa',
      region: 'US',
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.LOCAL],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.DEV,
      },
    },
    LAUNCH_DARKLY: {
      API_KEY: '5ae05ea368b4d92f10aedb60',
      USE_DEFAULTS: false,
    },
  },
  [ISSUES_ENV_TYPES.QA]: {
    DOCS: 'https://docs.b360-qa.autodesk.com',
    APIGEE_HOST: 'https://developer-stg.api.autodesk.com',
    DM_V2: '/dm-qa/v2',
    DM: '/dm-staging/v1/cmd-qa',
    RFIS_ENDPOINT: '/bim360/rfis-qa/v2',
    WORKFLOWS: '/workflows-qa/v1',
    DERIVATIVE_SERVICE: '/derivativeservice/v2',
    DOCS_SDK_CONFIG: {
      region: 'US',
      env: 'Qa',
    },
    REPORT_SDK_CONFIG: {
      env: 'Qa',
      region: 'US',
    },
    MATRIX_CONFIG: {
      env: 'QA',
      region: 'US',
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.QA],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.DEV,
      },
    },
    LAUNCH_DARKLY: {
      API_KEY: '5ae05e8216d8f82f3a32ed19',
      USE_DEFAULTS: false,
    },
  },
  [ISSUES_ENV_TYPES.STAGING]: {
    DOCS: 'https://docs.b360-staging.autodesk.com',
    APIGEE_HOST: 'https://developer-stg.api.autodesk.com',
    DM_V2: '/dm/v2',
    DM: '/dm-staging/v1/cmd-staging',
    RFIS_ENDPOINT: '/bim360/rfis-stg/v2',
    WORKFLOWS: '/workflows/v1',
    DERIVATIVE_SERVICE: '/derivativeservice/v2',
    DOCS_SDK_CONFIG: {
      region: 'US',
      env: 'Staging',
    },
    MATRIX_CONFIG: {
      env: 'STAGING',
      region: 'US',
    },
    REPORT_SDK_CONFIG: {
      env: 'Stg',
      region: 'US',
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.STAGING],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.DEV,
      },
    },
    LAUNCH_DARKLY: {
      API_KEY: '5ae05e2d60898c2e9ee26a37',
      USE_DEFAULTS: false,
    },
  },
  [ISSUES_ENV_TYPES.PROD]: {
    DOCS: 'https://docs.b360.autodesk.com',
    APIGEE_HOST: 'https://developer.api.autodesk.com',
    DM_V2: '/dm/v2',
    DM: '/dm/v1',
    RFIS_ENDPOINT: '/bim360/rfis/v2',
    WORKFLOWS: '/workflows/v1',
    DERIVATIVE_SERVICE: '/derivativeservice/v2',
    DOCS_SDK_CONFIG: {
      region: 'US',
      env: 'Production',
    },
    REPORT_SDK_CONFIG: {
      env: 'Prod',
      region: 'US',
    },
    MATRIX_CONFIG: {
      env: 'PROD',
      region: 'US',
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.PROD],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.PROD,
      },
    },
    LAUNCH_DARKLY: {
      API_KEY: '5ae05e2d60898c2e9ee26a38',
      USE_DEFAULTS: false,
    },
  },
};

const EMEA_CONFIG = {
  // When no EMEA specific config - use US config (dev, QA etc.)
  [ISSUES_ENV_TYPES.LOCAL]: US_CONFIG[ISSUES_ENV_TYPES.LOCAL],
  [ISSUES_ENV_TYPES.QA]: US_CONFIG[ISSUES_ENV_TYPES.QA],
  [ISSUES_ENV_TYPES.STAGING]: {
    DOCS: 'https://docs.b360-staging.eu.autodesk.com',
    APIGEE_HOST: 'https://developer-stg.api.autodesk.com',
    DM_V2: '/dm/v2',
    DM: '/dm-staging/v1/regions/eu/cmd-staging',
    RFIS_ENDPOINT: '/bim360/rfis-stg/v2',
    WORKFLOWS: '/workflows/v1',
    DERIVATIVE_SERVICE: '/derivativeservice/v2/regions/eu',
    DOCS_SDK_CONFIG: {
      region: 'EMEA',
      env: 'Staging',
    },
    REPORT_SDK_CONFIG: {
      env: 'Stg',
      region: 'EMEA',
    },
    MATRIX_CONFIG: {
      env: 'STAGING',
      region: 'EMEA',
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.STAGING],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.DEV,
      },
    },
    LAUNCH_DARKLY: {
      API_KEY: '5ae05e2d60898c2e9ee26a37',
      USE_DEFAULTS: false,
    },
  },
  [ISSUES_ENV_TYPES.PROD]: {
    DOCS: 'https://docs.b360.eu.autodesk.com',
    APIGEE_HOST: 'https://developer.api.autodesk.com',
    DM_V2: '/dm/v2',
    DM: '/dm/v1/regions/eu/cmd',
    RFIS_ENDPOINT: '/bim360/rfis/v2',
    WORKFLOWS: '/workflows/v1',
    DERIVATIVE_SERVICE: '/derivativeservice/v2/regions/eu',
    DOCS_SDK_CONFIG: {
      region: 'EMEA',
      env: 'Production',
    },
    REPORT_SDK_CONFIG: {
      env: 'Prod',
      region: 'EMEA',
    },
    MATRIX_CONFIG: {
      env: 'PROD',
      region: 'EMEA',
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.PROD],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.PROD,
      },
    },
    LAUNCH_DARKLY: {
      API_KEY: '5ae05e2d60898c2e9ee26a38',
      USE_DEFAULTS: false,
    },
  },
};

export const ENV_CONFIGS = {
  [ISSUES_REGIONS.US]: US_CONFIG,
  [ISSUES_REGIONS.EMEA]: EMEA_CONFIG,
};
